import { render, staticRenderFns } from "./PromotionUpdate.vue?vue&type=template&id=2dfc5801&scoped=true&"
import script from "./PromotionUpdate.vue?vue&type=script&lang=js&"
export * from "./PromotionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfc5801",
  null
  
)

export default component.exports